<div class="gh-siv-section">
  <div class="gh-siv-top-bar">
    <div class="gh-siv-title section-title">
      <i class="fs-16px sp-mr-10" ui-icon uiTheme="fill" uiType="links"></i>
      <h3>{{ "related_items" | localize }}</h3>
      <div class="gh-siv-section-action">
        <div class="add-section-item">
          <button
            #addItemBtn
            *ngIf="!hasViewOnlyRole && !showSelector"
            [attr.aria-label]="'add_new_related_item' | localize"
            (click)="addRelatedItem()"
            ui-button
            uiType="link"
            uiSize="default"
            uiShape="round"
            data-test-id="add-related-item-button">
            <i ui-icon uiType="plus"></i><span>{{ "add_item" | localize }}</span>
          </button>
          <i class="sp-ml-10" *ngIf="hasViewOnlyRole" [uiTooltipTitle]="tooltipTitle" ui-icon ui-tooltip uiType="info" uiTooltipPlacement="right"></i>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showSelector">
    <related-items-selector
      [relationsToExclude]="relationsToExclude"
      [currentItem]="linkSourceTarget"
      (relatedItemChange)="onRelatedItemChange($event)"
      data-test-id="related-items-selector"></related-items-selector>
  </ng-container>

  <div class="related-item-rows-container">
    <related-item-row
      *ngFor="let relatedItem of relatedItems | slice : 0 : limit"
      [relatedItem]="relatedItem"
      (updateLinkOption)="updateLink($event)"
      (deleteRelatedItem)="deleteLink($event)"
      data-test-id="related-item-rows"></related-item-row>
  </div>
  <button class="sp-mt-20" *ngIf="relatedItems.length > limit" [attr.aria-label]="showAllBtnLabel" (click)="setLimit()" ui-button uiType="link" uiSize="small" uiShape="round">
    {{ "show_all" | localize }} ({{ relatedItems.length }})
  </button>
  <button class="sp-mt-20" *ngIf="limit > defaultLimit" (click)="resetLimit()" ui-button uiType="link" uiSize="small" uiShape="round">
    {{ "show_less" | localize }}
  </button>
</div>
